<template>
  <span @click="emailLink(url, { subject, body })">
    <i
      class="fa fa-envelope-square fa-2x"
      :scale="scale"
      style="color:#ff4343"
    ></i>
  </span>
</template>

<script>
import objectToGetParams from "../utils/objectToGetParams";
export default {
  name: "email",
  methods: {
    emailLink(url, { subject, body }) {
      window.open(
        "mailto:" +
          objectToGetParams({
            subject,
            body: body || url
          }),
        "__blank"
      );
    }
  },
  props: {
    url: {
      type: String,
      required: true
    },
    scale: {
      required: false,
      type: String
    },
    subject: {
      required: false,
      type: String
    },
    body: {
      required: false,
      type: String
    }
  }
};
</script>
